import FreadomPointLeaderBoardList from "./FreadomPointLeaderBoardList"

export default  FreadomPointLeaderBoardList;
